/**
 * Helpers for the DataTables `render` callbacks, which return raw HTML strings
 * rather than React nodes. Anything derived from user data has to be escaped
 * here — React's automatic escaping does not apply.
 */

const HTML_ENTITIES = {
  '&': '&amp;',
  '<': '&lt;',
  '>': '&gt;',
  '"': '&quot;',
  "'": '&#39;',
};

export const escapeHtml = (value) => {
  if (value === null || value === undefined) return '';

  return String(value).replace(/[&<>"']/g, (char) => HTML_ENTITIES[char]);
};

/**
 * Newline-separated text into escaped HTML lines. Returns the placeholder when
 * there is nothing to show, matching the `defaultContent: '-'` used elsewhere.
 */
export const toLines = (value, placeholder = '-') => {
  const text = value === null || value === undefined ? '' : String(value);

  if (!text) return placeholder;

  return text.split('\n').map(escapeHtml).join('<br>');
};
